<template>
    <div>
        <div v-if="submitting">
            <loadingScreen></loadingScreen>
        </div>
        <section>
            <div class="top-nav-div">
                <div class="top-nav-elements">
                    <a href="#" class="link-block-42 w-inline-block">
                        <img :src="require('@/assets/images/NewSelf_Logo.png')" sizes="(max-width: 479px) 100vw, 84.03125px" :srcset="`${require('@/assets/images/NewSelf_Logo-p-500.png')} 500w, ${require('@/assets/images/NewSelf_Logo-p-800.png')} 800w`" loading="lazy" class="image-294">
                    </a>
                    <div class="form-nav-div">
                        <a href="#" @click.prevent="goBack" class="back-link w-inline-block" v-if="canGoBack">
                            <div class="text-block-507">&lt;-</div>
                        </a>
                        <div class="form-progress-div">
                            <div>
                                <div class="text-block-508">Step <strong>{{ currentStep }}</strong> of <strong>{{ totalSteps }}</strong></div>
                            </div>
                            <div class="form-precent-div">
                                <div class="text-block-509"><strong>{{ progressPercentage }}%</strong> Complete</div>
                            </div>
                        </div>
                    </div>
                    <div class="div-block-1442">
                        <div class="text-block-505"></div>
                    </div>
                </div>
            </div>
        </section>
    
        <section class="section-7">
            <div class="questions-div">
                <div class="question-content">
                    <div class="question-container" v-if="currentLocation">
                        <div class="question-div-2">
                            <div class="text-block-513">{{ currentLocation.data.label }}</div>
                            <div class="form-subs" v-if="currentLocation.data.description">{{ currentLocation.data.description }}</div>
                            
                                                    <!-- Radio Options -->
                            <div class="felix-form-block w-form" v-if="currentLocation.data.type === 'radio'">
                                <div class="div-block-1487">
                                    <a href="#" v-for="option in currentLocation.data.props.options" :key="option.value" @click.prevent="selectAnswer(option)" class="button-68 w-button">{{option.label}}</a>
                                </div>
                            </div>
    
                            <!-- Select Single Options -->
                            <div class="felix-form-block w-form" v-if="currentLocation.data.type === 'select' && currentLocation.data.mode === 'single'">
                                <a href="#" class="link-block-30 w-inline-block" v-for="option in currentLocation.data.props.options" :key="option.value" @click.prevent="selectAnswer(option)">
                                    <div>
                                        <div class="text-block-545">{{option.label}}</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                            </div>
    
                            <!-- Consent -->
                            <div v-if="currentLocation.data.type === 'consent'">
                                <div class="consent-text" v-html="currentLocation.data.consent_text"></div>
                                <div class="felix-form-block w-form">
                                    <a href="#" class="link-block-30 w-inline-block" v-for="option in currentLocation.data.props.options" :key="option.value" @click.prevent="selectAnswer(option)">
                                        <div>
                                            <div class="text-block-545">{{option.label}}</div>
                                        </div>
                                        <div>
                                            <div class="text-block-546">-></div>
                                        </div>
                                    </a>
                                </div>
                            </div>
    
                            <!-- Height Weight Input -->
                            <div class="felix-form-block w-form" v-if="currentLocation.data.type === 'height_weight'">
                                <div class="div-block-1478 mobile-entry form _2 height top">
                                    <input class="text-field-44 height w-input" maxlength="256" :value="height.feet" @input="handleHeightInput($event, 'feet')" placeholder="Feet" type="text" required>
                                    <input class="text-field-44 height w-input" maxlength="256" :value="height.inches" @input="handleHeightInput($event, 'inches')" placeholder="Inches" type="text" required>
                                </div>
                                <div class="div-block-1479 mobile-entry form _2 weight">
                                    <input class="text-field-45 weight w-input" maxlength="256" :value="weight" @input="handleWeightInput" placeholder="Weight in pounds" type="text" required>
                                </div>
                                <div v-if="bmi" class="bmi-result">
                                    Your BMI: {{ bmi.toFixed(1) }}
                                </div>
                            </div>
    
                            <!-- Checkbox Multiple Select -->
                            <div class="felix-form-block w-form" v-if="currentLocation.data.type === 'checkbox'">
                                <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="option in currentLocation.data.props.options" :key="option.value">
                                    <input type="checkbox" :value="option.value" v-model="checkboxAnswers[currentLocation._id]" @change="handleCheckboxChange($event, option)" class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label">{{option.label}}</span>
                                </label>
                            </div>
    
                            <!-- Textarea -->
                            <div class="felix-form-block w-form" v-if="currentLocation.data.type === 'textarea'">
                                <div class="condition-question mb-4">
                                    <textarea v-model="textAreaValue" placeholder="Enter your answer here" class="textarea w-input" rows="3" required></textarea>
                                </div>
                            </div>
    
                            <!-- Radio More -->
                            <div class="felix-form-block w-form" v-if="currentLocation.data.type === 'radio_more'">
                                <form>
                                    <a href="#" class="link-block-30 w-inline-block" v-for="option in currentLocation.data.props.options" :key="option.value" @click.prevent="selectAnswer(option)">
                                        <div>
                                            <div class="text-block-545">{{option.label}}</div>
                                        </div>
                                        <div>
                                            <div class="text-block-546">-></div>
                                        </div>
                                    </a>
                                </form>
                            </div>
    
                            <!-- Image Choice -->
                            <div class="felix-form-block w-form" v-if="currentLocation.data.type === 'image_choice'">
                                <div class="div-block-1487">
                                    <a href="#" v-for="option in currentLocation.data.props.options" :key="option.value" @click.prevent="selectAnswer(option)" class="button-68 w-button">{{option.label}}</a>
                                </div>
                            </div>
    
                            <!-- Image Upload -->
                            <div class="felix-form-block w-form" v-if="currentLocation.data.type === 'image_upload'">
                                <ImageUploader image-type="prescription_image" :question-id="currentLocation._id" @image-uploaded="handleImageUploaded" />
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </section>
    </div>
    </template>
    
    <script>
    import loadingScreen from "../common/submittionLoader.vue"
    import questionsTrlegra from "@/utils/telegraQuestion.json"
    export default {
        name: 'QuestionsStepsLoader',
        
        components: {
            loadingScreen
        },
    
        data() {
            return {
                questionnaire: questionsTrlegra.questionnaire,
                submitting: false,
                currentLocationId: null,
                selectedValue: null,
                answerHistory: [], // [{location: "", value: ""}]
                baseUrl: process.env.VUE_APP_API_ENDPOINT,
                height: {
                    feet: '',
                    inches: ''
                },
                weight: '',
                checkboxAnswers: {},
                textAreaValue: '',
                imagePreview: null
            }
        },
    
        computed: {
            bmi() {
                return this.calculateBMI()
            },
    
            isHeightWeightValid() {
                const feet = parseInt(this.height.feet)
                const inches = parseInt(this.height.inches)
                const weight = parseInt(this.weight)
    
                return feet >= 4 && feet <= 8 && 
                    inches >= 0 && inches <= 11 && 
                    weight >= 50 && weight <= 1000 
            },
    
            currentLocation() {
                if (!this.currentLocationId || !this.questionnaire?.locations) return null
                return this.questionnaire.locations.find(loc => loc._id === this.currentLocationId)
            },
    
            totalSteps() {
                return this.questionnaire?.locations?.length || 0
            },
    
            currentStep() {
                if (!this.currentLocationId || !this.questionnaire?.locations) return 1
                return this.questionnaire.locations.findIndex(loc => loc._id === this.currentLocationId) + 1
            },
    
            progressPercentage() {
                return Math.round((this.currentStep / this.totalSteps) * 100)
            },
    
            canGoBack() {
                return this.currentStep > 1
            },
    
            instanceId() {
                return this.questionnaire?._id
            }
        },
    
        methods: {
            // Height/Weight handling methods
            handleHeightInput(event, field) {
                const value = event.target.value.replace(/[^0-9]/g, '')
                if (field === 'feet') {
                    this.height.feet = value
                } else {
                    this.height.inches = value
                    if (parseInt(value) >= 12) {
                        this.height.inches = '11'
                    }
                }
                if (this.isHeightWeightValid) {
                    this.submitHeightWeight()
                }
            },
    
            handleWeightInput(event) {
                const value = event.target.value.replace(/[^0-9]/g, '')
                this.weight = value
                if (this.isHeightWeightValid) {
                    this.submitHeightWeight()
                }
            },
    
            async submitHeightWeight() {
                const payload = {
                    location: this.currentLocationId,
                    value: JSON.stringify({
                        height: this.height,
                        weight: this.weight,
                        bmi: this.calculateBMI()
                    })
                }
                await this.submitAnswer(payload)
            },
    
            calculateBMI() {
                if (this.height.feet && this.height.inches && this.weight) {
                    const heightInInches = (parseInt(this.height.feet) * 12) + parseInt(this.height.inches)
                    return (parseInt(this.weight) * 703) / (heightInInches * heightInInches)
                }
                return null
            },
    
            // Checkbox handling methods
            async handleCheckboxChange(event, option) {
                const locationId = this.currentLocationId
                if (!this.checkboxAnswers[locationId]) {
                    this.$set(this.checkboxAnswers, locationId, [])
                }
    
                const value = option.value
                const checked = event.target.checked
    
                if (checked) {
                    this.checkboxAnswers[locationId].push(value)
                } else {
                    const index = this.checkboxAnswers[locationId].indexOf(value)
                    if (index > -1) {
                        this.checkboxAnswers[locationId].splice(index, 1)
                    }
                }
    
                // Submit checkbox answers
                const payload = {
                    location: locationId,
                    value: JSON.stringify(this.checkboxAnswers[locationId])
                }
                await this.submitAnswer(payload)
            },
    
            // Image upload handling
            handleImageUploaded(data) {
                const payload = {
                    location: this.currentLocationId,
                    value: data.base64
                }
                this.submitAnswer(payload)
            },
    
            // Original methods continue here...
            findFirstQuestion() {
                if (!this.questionnaire?.locations?.length) return null
                
                // Find location ending with :1
                const firstQuestion = this.questionnaire.locations.find(loc => 
                    loc._id.split(':').pop() === '1'
                )
                
                return firstQuestion?._id || null
            },
    
            async selectAnswer(option) {
                try {
                    this.submitting = true
                    this.selectedValue = option.value
    
                    // Prepare answer payload
                    const payload = {
                        location: this.currentLocationId,
                        value: option.value
                    }
    
                    // Add to answer history
                    const existingAnswerIndex = this.answerHistory.findIndex(a => a.location === this.currentLocationId)
                    if (existingAnswerIndex !== -1) {
                        this.answerHistory[existingAnswerIndex] = payload
                    } else {
                        this.answerHistory.push(payload)
                    }
    
                    // Submit answer
                    await this.submitAnswer(payload)
    
                    // Navigate to next question
                    if (option.next) {
                        // Clear subsequent answers if answer changed and leads to different path
                        const previousAnswer = this.answerHistory.find(a => a.location === this.currentLocationId)
                        if (previousAnswer && previousAnswer.value !== option.value) {
                            const currentIndex = this.questionnaire.locations.findIndex(loc => loc._id === this.currentLocationId)
                            this.answerHistory = this.answerHistory.slice(0, currentIndex + 1)
                        }
                        
                        this.currentLocationId = option.next
                        this.selectedValue = null
                    }
    
                } catch (error) {
                    console.error('Error submitting answer:', error)
                    // Handle error appropriately
                } finally {
                    this.submitting = false
                }
            },
    
            async submitAnswer(payload) {
                try {
                    console.log(payload)
                    return "success"
                    /*const response = await this.$axios.put(
                        `/questionnaireInstances/${this.instanceId}/actions/answerLocation?shouldNavigateNext=true`,
                        payload
                    )
                    return response.data*/
                } catch (error) {
                    console.error('Error submitting answer:', error)
                    throw error
                }
            },
    
            goBack() {
                if (!this.canGoBack) return
    
                const currentIndex = this.questionnaire.locations.findIndex(loc => loc._id === this.currentLocationId)
                if (currentIndex > 0) {
                    this.currentLocationId = this.questionnaire.locations[currentIndex - 1]._id
                    this.selectedValue = null
                }
            },
    
            initializeFromResponses() {
                if (!this.questionnaire?.responses?.length) return
    
                this.answerHistory = this.questionnaire.responses.map(response => ({
                    location: response.location._id,
                    value: response.value
                }))
            }
        },
    
        created() {
            // Initialize with first question or current location from questionnaire
            console.log("Loading questions")
            this.currentLocationId = this.questionnaire?.currentLocation || this.findFirstQuestion()
            this.initializeFromResponses()
        }
    }
    </script>
    
    <style scoped>
    .balugabtn {
        margin-top: -40px !important;
        padding-top: 15px !important;
    }
    
    .selected {
        background-color: #e2e8f0;
    }
    
    .button-68.selected {
        background-color: #4299e1;
        color: white;
    }
    </style>